import React from 'react';

import Switch from 'devextreme-react/switch';

import DataModelView from '../../common/view/DataModelView';
import NumberUtils from '../../common/utils/NumberUtils';

export default class FlexHoursSummaryView extends DataModelView {
  getIntegratedPropertyNames() {
    return [
      'showHourUnits',
      'contracts',
      'isAllocationExceeded'
    ];
  }

  render() {
    return (
      <div>
        {this.state.contracts.map((contract, index) => {
          return (
            <div key={contract.code} className="dx-fieldset">
              <div className="dx-fieldset-header">
                <span className="pwx-header-span">{contract.displayName}</span>
                {
                  index === 0
                    ? (
                      <span className="pwx-switch-span">
                        <Switch
                          switchedOffText="MWh"
                          switchedOnText="Hours"
                          value={this.state.showHourUnits}
                          onValueChanged={this.onShowHourUnitsChanged.bind(this)}
                        />
                      </span>
                    )
                    : (<span />)
                }
              </div>
              <div className="dx-field">
                <div className="dx-field-label">Quantity (MWh)</div>
                <div className="dx-field-value-static">
                  {NumberUtils.formatNumber(contract.hourlyEnergyMaximum, this.props.locale)}
                </div>
              </div>
              <div className="dx-field">
                <div className="dx-field-label">
                  1x16 Flex Available
                </div>
                <div className="dx-field-value-static">
                  {this.state.showHourUnits
                    ? NumberUtils.formatNumber(contract.flexAvailableH, this.props.locale)
                    : NumberUtils.formatNumber(contract.flexAvailableMWh, this.props.locale)
                  }
                </div>
              </div>
              <div className="dx-field">
                <div className={resolveAlertClass('dx-field-label', contract.isAllocationExceeded)}>
                  1x16 Flex Taken
                </div>
                <div className={resolveAlertClass('dx-field-value-static', contract.isAllocationExceeded)}>
                  {this.state.showHourUnits
                    ? NumberUtils.formatNumber(contract.flexTakenH, this.props.locale)
                    : NumberUtils.formatNumber(contract.flexTakenMWh, this.props.locale)
                  }
                </div>
              </div>
              <div className="dx-field">
                <div className={resolveAlertClass('dx-field-label', contract.isAllocationExceeded)}>
                  1x16 Flex Remaining
                </div>
                <div className={resolveAlertClass('dx-field-value-static', contract.isAllocationExceeded)}>
                  {this.state.showHourUnits
                    ? NumberUtils.formatNumber(contract.flexRemainingH, this.props.locale)
                    : NumberUtils.formatNumber(contract.flexRemainingMWh, this.props.locale)
                  }
                </div>
              </div>
            </div>
          )
        })}
      </div>
    );
  }

  onShowHourUnitsChanged(event) {
    this.dataModel.updateProperties({
      showHourUnits: event.value
    });
  }
}

function resolveAlertClass(primaryClassName, isAlertVisible) {
  return primaryClassName + (isAlertVisible ? ' pwx-alert' : '');
}